{
  "home-page-title": "Webapp",
  "clear-btn": "清除",
  "close-btn": "關閉",
  "cancel-btn": "取消",
  "delete-btn": "刪除",
  "share-btn": "分享",
  "download-btn": "下載",
  "favorite-btn": "收藏",
  "ok-btn": "確認",
  "done-btn": "完成",
  "yes-btn": "是",
  "no-btn": "否",
  "create-story-btn": "建立故事",
  "submit-registration-btn": "開啟相簿",
  "save-btn": "儲存",
  "apply-btn": "套用",
  "checkout-btn": "結帳",
  "info-title": "資訊",
  "registration-page-title": "註冊",
  "contact-completion-page-title": "完成聯絡資料",
  "registration-name-placeholder": "您的姓名",
  "registration-email-placeholder": "您的電子郵件",
  "registration-email-or-phone-placeholder": "您的電子郵件或美國電話號碼",
  "registration-country-code-default": "美國 +1",
  "registration-accept-label": "我同意",
  "registration-privacy-link": "條款與細則",
  "registration-sms-agreement-label": "我同意接收來自 Storibox 的通知訊息至上方提供的電話號碼。我明白我將收到包含更新與圖片連結的 SMS 訊息。可能會產生數據及訊息費用。如要取消，請回覆 STOP。",
  "registration-submit-loading-label": "載入中...",
  "registration-create-attendee-error-message": "建立使用者失敗。請稍後再試。",
  "registration-create-attendee-email-confirmation-error-message": "建立使用者失敗。請稍後再試。請確認您的電子郵件已完成驗證。",
  "registration-invalid-us-phone-message": "請僅使用美國電話號碼，例如：+11234567890。",
  "registration-us-phone-length-message": "電話號碼在國碼（+1）後應為 10 位數，但您輸入的是 {{length}} 位。",
  "registration-contact-required-message": "電子郵件或電話號碼為必填。",
  "registration-invalid-email-message": "請輸入有效的電子郵件地址。",
  "registration-email-required-message": "電子郵件為必填。",
  "registration-sms-consent-required-message": "您必須同意 SMS 條款，否則無法註冊此服務。",
  "registration-privacy-consent-required-message": "您必須同意條款與細則，否則無法註冊此服務。",
  "selfies-empty-title": "尚未有自拍！",
  "selfies-empty-message": "請為同行的每位成員\n新增清晰的人像照片，\n以便快速找到\n您的影像。",
  "selfies-add-btn": "+ 新增",
  "selfie-upload-window-expired-message": "在此活動中使用自拍搜尋您照片的時間窗口已到期。",
  "purchase-btn": "購買",
  "home-select-all-btn": "全選",
  "home-selected-count-label_one": "已選擇 1 項",
  "home-selected-count-label_other": "已選擇 {{count}} 項",
  "home-empty-album-message": "相簿是空的",
  "home-empty-album-subtext-message": "您的相簿中<br>目前沒有任何圖片。",
  "home-qr-modal-title": "我的相簿代碼",
  "home-qr-modal-message": "請在自助機掃描此 QR 以存取您的照片，或在流動攝影師要求時出示。",
  "home-qr-scanner-message": "掃描照片自助機中您照片或影片上的 QR code，將媒體與此應用程式連結。",
  "home-qr-camera-access-message": "🎥 請確認您已開啟相機權限以掃描 QR code。",
  "home-qr-scanner-show-my-qr-btn": "顯示我的 QR",
  "menu-registered-selfies": "已登記的人臉",
  "menu-qr-scanner": "QR 掃描器",
  "menu-album-code": "我的相簿代碼",
  "menu-privacy": "條款與細則",
  "menu-faq": "常見問題",
  "menu-support": "支援",
  "home-step-label": "步驟 {{amount}} / {{total}}",
  "home-select-up-to-images-title_one": "最多選擇 1 張圖片",
  "home-select-up-to-images-title_other": "最多選擇 {{count}} 張圖片",
  "home-select-as-many-images-title": "可選擇任意數量的圖片",
  "home-select-target-label": "用於「{{name}}」",
  "home-no-albums-found-message": "找不到任何相簿。",
  "home-event-config-missing-message": "此活動尚未設定 Web 應用。",
  "home-create-story-waiting-message": "正在建立您的故事。請幾分鐘後再查看相簿。",
  "home-ugc-tooltip-message": "您可以從相簿上傳照片，並在自助機列印！",
  "home-face-reco-tooltip-message": "請上傳您的自拍，或同行每位成員清晰的人像照片，以便我們找到您的影像！",
  "home-select-to-share-or-download-message": "請至少選擇一張圖片以分享或下載。",
  "home-select-without-watermark-message": "只有無浮水印的圖片可分享或下載。",
  "home-select-to-delete-message": "請至少選擇一張圖片以刪除。",
  "home-share-download-locked-message": "您選擇的部分照片已被鎖定。若要分享或下載，請購買 Digital Pass。",
  "home-face-register-help-message": "請確保臉部光線均勻且完整可見，並保持自然表情。",
  "home-no-selfies-suggestion-message": "看起來您尚未登記自拍。立即拍攝自拍以獲取珍貴回憶。",
  "home-no-face-mask-message": "請勿佩戴口罩",
  "home-selfie-maybe-later-btn": "稍後",
  "home-delete-stock-warning-message": "您選擇了活動素材圖片要刪除。此圖片無法從您的相簿刪除，將被略過。",
  "home-delete-confirm-message": "從相簿刪除圖片後無法復原。確定要繼續嗎？",
  "home-delete-reason-not-wanted": "我不想要這些圖片在相簿中",
  "home-delete-reason-not-mine": "這些不是我的圖片",
  "home-delete-confirm-btn": "是，刪除",
  "home-upload-unsupported-format-message": "不支援的圖片格式。請使用其他圖片檔案。",
  "home-upload-generic-error-message": "上傳照片時發生錯誤。請重試或聯絡支援。",
  "home-upload-limit-reached-message": "您已達照片上傳上限。如需上傳更多照片，請聯絡支援。",
  "home-upload-processing-error-message": "處理照片時發生錯誤。請重試或聯絡支援。",
  "home-upload-processing-message": "您的照片將於一分鐘內出現在相簿中！",
  "home-upload-photo-message": "從相簿上傳照片以供列印！",
  "home-turn-me-into-tag-upload-message": "拍攝自拍，或從相簿上傳人像照片。",
  "home-turn-me-into-tag-processing-message": "我們正在轉換您的圖片！請約一分鐘後重新整理此頁面。",
  "home-download-waiting-message": "正在下載檔案。<br/>請稍候。",
  "download-selection-too-large-message": "抱歉，此選取內容太大，無法一次下載。請選擇較少照片，或逐張下載。",
  "home-download-360-message": "這是互動內容，建議於相簿內檢視。您仍可下載原始檔案以在線上分享，或日後在支援 360 球形格式的應用程式中檢視。",
  "home-scanned-image-confirm-message": "很棒的照片！為了安全請確認：這是您的圖片嗎？",
  "home-media-share-title": "媒體",
  "webapp-share-title": "來看看我的 Storibox 相簿！",
  "webapp-ogp-title": "我的 Storibox 相簿",
  "webapp-ogp-description": "查看並分享我在 Storibox 相簿中的照片與影片。",
  "home-share-files-unsupported-message": "您的瀏覽器不支援檔案分享。請使用其他瀏覽器，或直接下載檔案。",
  "home-share-files-waiting-message": "正在下載要分享的檔案。<br/>請稍候。",
  "title-select-a-combo": "選擇組合",
  "title-select-a-la-carte": "單點項目",
  "title-shopping-cart": "購物車",
  "checkout-change-image-btn": "更換圖片",
  "checkout-empty-cart-message": "購物車是空的",
  "checkout-add-product-btn": "新增商品",
  "checkout-subtotal-label": "小計:",
  "checkout-taxes-label": "稅金 (0%)",
  "checkout-total-label": "總金額:",
  "checkout-promo-code-placeholder": "優惠代碼",
  "checkout-add-on-btn": "+ 加購",
  "checkout-invalid-promo-code-message": "無效或不適用的優惠代碼！",
  "checkout-discount-label": "折扣: {{title}}",
  "checkout-delete-restriction-message": "如要購買加購項目，購物車中必須至少保留一個套裝。若需更換套裝，請先移除購物車中的所有加購項目。",
  "checkout-digital-package-upsell-message": "要將<br>數位套裝加入<br>購物車，並取得<br>所有數位內容的存取權嗎？",
  "checkout-tip-message": "要新增小費嗎？",
  "checkout-tip-description": "您的小費將幫助支持團隊。",
  "checkout-no-tip-btn": "不給小費",
  "photo-plus-maybe-later-btn": "稍後",
  "photo-plus-upgrade-btn": "是，立即升級",
  "checkout-digital-package-duplicate-message": "您的購物車中已包含數位存取套裝。<br>在移除或購買目前套裝之前，無法新增新套裝。",
  "title-change-image": "選擇照片",
  "title-select-images": "選擇照片",
  "title-registered-selfies": "已登記的人臉",
  "title-privacy": "條款與細則",
  "title-faq": "常見問題",
  "title-shoot": "拍攝",
  "title-remote-shoot": "遠端拍攝",
  "title-thank-you": "謝謝",
  "thank-you-header": "感謝您的購買！",
  "thank-you-message": "請點擊「返回相簿」按鈕以查看您的新照片。",
  "thank-you-go-to-album-btn": "返回相簿",
  "order-pickup": "請在列印站領取您的照片。",
  "shoot-again-btn": "再拍一次",
  "select-image-done-btn-name_final": "完成",
  "select-image-done-btn-name_incomplete": "下一步",
  "select-image-done-btn-counter_finite": "({{amount}}/{{total}})",
  "select-image-done-btn-counter_infinite": "({{amount}})",
  "remote-shoot-btn": "拍攝",
  "remote-shoot-start-message": "請看著鏡頭，準備好後按「拍攝」",
  "remote-shoot-countdown-message": "請看著燈號",
  "remote-shoot-rendering-message": "正在建立您的內容。幾秒後請查看相簿，欣賞全新精彩影片！"
}
